import { useState } from "react";
import { Modal, Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwtInterceoptor from "./shared/jwtInterceptor";
import { baseURL } from "../services/api";

const UploadDocument = ({ open, onClose, organisationId, onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [type, setType] = useState("statu_pv");
    const [loading, setLoading] = useState(false);

    const handleUpload = async () => {
        if (!file) {
            toast.error("Sélectionnez un fichier !");
            return;
        }

        console.log("Fichier sélectionné :", file); // Debug: Vérifiez que le fichier est bien défini

        const formData = new FormData();
        formData.append("organisation_id", organisationId);
        formData.append("type_document", type);
        formData.append("document", file);

        try {
            setLoading(true);
            const res = await jwtInterceoptor.post(`${baseURL}/data/documents`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            toast.success(res.data.message);
            setFile(null);
            setType("statu_pv");
            if (onUploadSuccess) onUploadSuccess();
            onClose();
        } catch (error) {
            console.error("Upload Error:", error.response?.data || error.message);
            toast.error("Erreur lors de l'upload");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <Typography variant="h6">Ajouter un Document</Typography>
                <Select value={type} onChange={(e) => setType(e.target.value)} fullWidth>
                    <MenuItem value="statu_pv">Statuts PV</MenuItem>
                    <MenuItem value="ago">AGO</MenuItem>
                    <MenuItem value="age">AGE</MenuItem>
                </Select>
                <input
                    type="file"
                    onChange={(e) => {
                        const selectedFile = e.target.files[0];
                        if (selectedFile) {
                            console.log("Fichier chargé :", selectedFile); // Debug: Vérifiez que le fichier est chargé
                            setFile(selectedFile);
                        }
                    }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                    disabled={loading}
                >
                    {loading ? "Uploading..." : "Uploader"}
                </Button>
            </Box>
        </Modal>
        </>
    );
};

export default UploadDocument;
